import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import { PortfolioCovenantsContainer } from 'packages/borrowing-base/ui/PortfolioCovenantsContainer';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const InsightsPortfolioCovenantsRoute = () => {
  const flags = useFeatureFlags();
  const toast = useToast();
  const navigate = useNavigate();

  if (!flags.displayPortfolioCovenants) {
    return <Navigate to="/" />;
  }

  let routeLevelError = false;

  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights portfolio covenants page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <InsightsTemplate selectedTab={TAB_OPTION_KEYS.portfolioCovenants}>
          <CapitalProviderContextProvider renderLoading={<Skeleton />}>
            <PortfolioCovenantsContainer />
          </CapitalProviderContextProvider>
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
